import React, { forwardRef, memo } from 'react'

const CoinIcon = forwardRef<SVGSVGElement, React.SVGProps<SVGSVGElement>>(
  (props, ref) => (
    <svg
      ref={ref}
      width="56.7"
      height="56"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 56.7 56"
      fill="none"
      stroke="#78BE20"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}>
      <circle
        cx="28.35"
        cy="28"
        r="26.871"
        fill="#fff"
        stroke="#eee"
        strokeWidth={2.259}
      />
      <path
        d="M26.25 36.4c2.706 0 4.9-3.761 4.9-8.4s-2.194-8.4-4.9-8.4-4.9 3.761-4.9 8.4 2.194 8.4 4.9 8.4Z"
        strokeWidth={1.4}
      />
      <path
        d="M26.25 19.6h4.2c2.706 0 4.9 3.763 4.9 8.4s-2.194 8.4-4.9 8.4h-4.2"
        strokeWidth={1.4}
      />
      <path
        d="M29.902 22.4h4.2M31.15 28h4.2M29.902 33.6h4.2"
        strokeWidth={1.4}
      />
    </svg>
  )
)

CoinIcon.displayName = 'CoinIcon'
export default memo(CoinIcon)
